module.exports = __webpack_public_path__ + "static/img/squareyard.14910424.jpeg";